document.addEventListener('DOMContentLoaded', () => {
  const accordion = document.querySelector('[data-seo-accordion]');
  if (!accordion) return;

  const trigger = accordion.querySelector('[data-seo-trigger]');
  const content = accordion.querySelector('[data-seo-content]');

  if (!trigger || !content) return;

  trigger.addEventListener('click', () => {
    const isOpen = trigger.getAttribute('aria-expanded') === 'true';
    const newState = !isOpen;

    trigger.setAttribute('aria-expanded', String(newState));
    content.setAttribute('aria-hidden', String(!newState));

    if (newState) {
      accordion.setAttribute('data-open', '');
    } else {
      accordion.removeAttribute('data-open');
    }
  });
});
